import React from "react";
import { Index } from "../components/Blog/Index";

export const Blog = () => {
  return <Index />;
};
